window.addEventListener('load', function () {
    const track = document.querySelector('.custom-carousel-track');
    let slides = Array.from(document.querySelectorAll('.custom-slide'));
    const dots = document.querySelectorAll('.custom-dots .dot');
    const leftArrow = document.querySelector('.carousel-arrow.left');
    const rightArrow = document.querySelector('.carousel-arrow.right');
  
    const gap = 0;
    let index = 1;
    let isTransitioning = false;
  
    function getSlideWidth() {
      const slide = slides[0];
      const style = getComputedStyle(slide);
      const width = slide.getBoundingClientRect().width;
      const marginLeft = parseFloat(style.marginLeft);
      const marginRight = parseFloat(style.marginRight);
      return width + marginLeft + marginRight;
    }
  
    function getOffset(index) {
      const slideWidth = getSlideWidth();
      const slideWidthWithGap = slideWidth + gap;
      const containerWidth = track.parentElement.clientWidth;
      return -((slideWidthWithGap * index) - (containerWidth / 2) + (slideWidth / 2));
    }
  
    function updateDots() {
      dots.forEach(dot => dot.classList.remove('active'));
      let activeIndex = index - 1;
      if (activeIndex < 0) activeIndex = dots.length - 1;
      if (activeIndex >= dots.length) activeIndex = 0;
      dots[activeIndex].classList.add('active');
    }
  
    function moveToSlide(i) {
      if (isTransitioning) return;
      isTransitioning = true;
      index = i;
  
      const offset = getOffset(index);
      track.style.transition = 'transform 0.5s ease-in-out';
      track.style.transform = `translateX(${offset}px)`;
  
      updateDots();
    }
  
    track.addEventListener('transitionend', () => {
      isTransitioning = false;
  
      if (index === 0) {
        index = dots.length;
        track.style.transition = 'none';
        track.style.transform = `translateX(${getOffset(index)}px)`;
      }
  
      if (index === dots.length + 1) {
        index = 1;
        track.style.transition = 'none';
        track.style.transform = `translateX(${getOffset(index)}px)`;
      }
    });
  
    function nextSlide() {
      if (isTransitioning) return;
      moveToSlide(index + 1);
    }
  
    function prevSlide() {
      if (isTransitioning) return;
      moveToSlide(index - 1);
    }
  
    let autoplay = setInterval(nextSlide, 5000);
  
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        clearInterval(autoplay);
        moveToSlide(i + 1);
        autoplay = setInterval(nextSlide, 5000);
      });
    });
  
    rightArrow.addEventListener('click', () => {
      clearInterval(autoplay);
      nextSlide();
      autoplay = setInterval(nextSlide, 5000);
    });
  
    leftArrow.addEventListener('click', () => {
      clearInterval(autoplay);
      prevSlide();
      autoplay = setInterval(nextSlide, 5000);
    });
  
    let startX = 0;
    let isSwiping = false;
    
    function handleSwipeEnd(endX) {
      const diff = endX - startX;
    
      if (Math.abs(diff) > 50) {
        if (diff < 0) nextSlide();
        else prevSlide();
      }
      autoplay = setInterval(nextSlide, 5000);
      isSwiping = false;
    }
    
    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      isSwiping = true;
      clearInterval(autoplay);
    });
    
    track.addEventListener('touchend', function (e) {
      if (!isSwiping) return;
      const endX = e.changedTouches[0].clientX;
      handleSwipeEnd(endX);
    });
    
    track.addEventListener('mousedown', function (e) {
      startX = e.clientX;
      isSwiping = true;
      clearInterval(autoplay);
    });
    
    document.addEventListener('mouseup', function (e) {
      if (!isSwiping) return;
      const endX = e.clientX;
      handleSwipeEnd(endX);
    });
  
    const initialOffset = getOffset(index);
    track.style.transition = 'none';
    track.style.transform = `translateX(${initialOffset}px)`;
  
    requestAnimationFrame(() => {
      track.style.transition = 'transform 0.5s ease-in-out';
    });
    
    track.classList.remove('not-initialized');

    updateDots();
  });